import get from 'lodash/get';

export const getCmsRelatedNavigation = data => get(data, 'nodes[0].relatedNavigation', []);
export const getCmsPageTitle = data => get(data, 'nodes[0].pageTitle', {});
